module.exports = __webpack_public_path__ + "img/20251226.11732204.jpg";